import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import color_prediction from "../features/games/color_prediction/Slice";
import toss_karo from "../features/games/toss_karo/Slice";
import andar_bahar from "../features/games/andar_bahar/Slice";
import double_roulette from "../features/games/double_roulette/Slice";
import roulette from "../features/games/roulette/Slice";

const games = combineReducers({
  color_prediction: color_prediction,
  toss_karo: toss_karo,
  andar_bahar: andar_bahar,
  double_roulette: double_roulette,
  roulette: roulette,
});

export default games;
